import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AssetViewerComponent} from '../edc-demo/components/asset-viewer/asset-viewer.component';
import {CatalogBrowserComponent} from '../edc-demo/components/catalog-browser/catalog-browser.component';
import {IntroductionComponent} from '../edc-demo/components/introduction/introduction.component';
import {
  ContractDefinitionViewerComponent
} from '../edc-demo/components/contract-definition-viewer/contract-definition-viewer.component';
import {
  TransferHistoryViewerComponent
} from '../edc-demo/components/transfer-history/transfer-history-viewer.component';
import {PolicyViewComponent} from "../edc-demo/components/policy-view/policy-view.component";
import {ContractViewerComponent} from "../edc-demo/components/contract-viewer/contract-viewer.component";
import {LogoutPageComponent} from '../edc-demo/components/logout-page/logout-page.component';
import {AuthGuard} from "./guard/auth.guard";

export const routes: Routes = [
  {
    path: 'dashboard',
    component: IntroductionComponent,
    data: {title: 'Dashboard', icon: 'dashboard'},
    canActivate: [AuthGuard]
  },
  {
    path: 'catalog-browser',
    component: CatalogBrowserComponent,
    data: {title: 'Catalog Browser', icon: 'menu_book'},
    canActivate: [AuthGuard]
  },
  {
    path: 'contracts',
    component: ContractViewerComponent,
    data: {title: 'Contracts', icon: 'description'},
    canActivate: [AuthGuard]
  },
  {
    path: 'transfer-history',
    component: TransferHistoryViewerComponent,
    data: {title: 'Transfer History', icon: 'history'},
    canActivate: [AuthGuard]
  },
  {
    path: 'data-offers',
    component: ContractDefinitionViewerComponent,
    data: {title: 'Data Offers', icon: 'upload'},
    canActivate: [AuthGuard]
  },
  {
    path: 'policies',
    component: PolicyViewComponent,
    data: {title: 'Policies', icon: 'policy'},
    canActivate: [AuthGuard]
  },
  {
    path: 'my-assets', // must not be "assets" to prevent conflict with assets directory
    component: AssetViewerComponent,
    data: {title: 'Assets', icon: 'inbox'},
    canActivate: [AuthGuard]
  },
  {
    path: '', redirectTo: 'dashboard', pathMatch: 'full',
  },
  {
    path: 'logout',
    component: LogoutPageComponent,
    data: {title: 'Logout', icon: 'logout'},
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
